import { combineReducers, createSlice, PayloadAction } from "@reduxjs/toolkit";
// Simplified State Interfaces
interface IRequirementType {
   value: string; // Change this if you want to store a simple string
}

interface ISupportType {
   supportValue: string; // Change this if you want to store a simple string
}

interface IDoorstepOrderType {
   doorstepOrderVal: string
}

interface IWithdrawOption {
   option: string
}
// Initial States
const initialStateReq: IRequirementType = {
   value: "Work",
};

const initialStateHelp: ISupportType = {
   supportValue: "Worker",
};

const initialStateOrder: IDoorstepOrderType = {
   doorstepOrderVal: "Normal",
};

const initialStateWithdrawOption: IWithdrawOption = {
   option: "Pending",
};
// Requirement Type Slice
export const requirementTypeSlice = createSlice({
   name: "requirementType",
   initialState: initialStateReq,
   reducers: {
      setRequirementType: (state, action: PayloadAction<string>) => {
         state.value = action.payload;
      },
   },
});

// Support Type Slice
export const helpAndSupportTypeSlice = createSlice({
   name: "supportType",
   initialState: initialStateHelp,
   reducers: {
      setSupportValue: (state, action: PayloadAction<string>) => {
         state.supportValue = action.payload;
      },
   },
});

// Doorstep Order Type Slice
export const doorstepOrderTypeSlice = createSlice({
   name: "doorstepOrderType",
   initialState: initialStateOrder,
   reducers: {
      setOrderTypeValue: (state, action: PayloadAction<string>) => {
         state.doorstepOrderVal = action.payload;
      },
   },
});

// Withdraw Type Slice
export const withdrawOptionSlice = createSlice({
   name: "withdrawOption",
   initialState: initialStateWithdrawOption,
   reducers: {
      setWithdrawOptionValue: (state, action: PayloadAction<string>) => {
         state.option = action.payload;
      },
   },
});


export const { setRequirementType } = requirementTypeSlice.actions;
export const { setSupportValue } = helpAndSupportTypeSlice.actions;
export const { setOrderTypeValue } = doorstepOrderTypeSlice.actions;
export const { setWithdrawOptionValue } = withdrawOptionSlice.actions;


// Combine the reducers if you are using multiple reducers in your store
const combineReducer = combineReducers({
   requirementType: requirementTypeSlice.reducer,
   supportType: helpAndSupportTypeSlice.reducer,
   doorstepOrderType: doorstepOrderTypeSlice.reducer,
   withdrawOption: withdrawOptionSlice.reducer,

});

export default combineReducer;
